import React from 'react';
import PropTypes from 'prop-types';

const EnergyLabelModal = props => (
  <div className="energylabel-container">
    <img src={props.energyLabelImage} alt="energy label" />
    <div className="modal-footer">
      <button
        className="btn btn-default"
        onClick={props.closeModal}
      >
        {props.closeText}
      </button>
    </div>
  </div>
);

EnergyLabelModal.propTypes = {
  energyLabelImage: PropTypes.string,
  closeModal: PropTypes.func,
  closeText: PropTypes.string,
};

EnergyLabelModal.defaultProps = {
  energyLabelImage: '',
  closeModal: null,
  closeText: 'close',
};

export default EnergyLabelModal;



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/EnergyLabels/EnergyLabelModal.js